// src/store.js
import { combineReducers, configureStore } from "@reduxjs/toolkit";
import userReducer from "../slices/userSlice";
import configReducer from "../slices/configSlice";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";

const persistConfig = {
  key: "agro-hub",
  storage,
  whitelist: ["config"],
  blacklist: ["user"],
};

const rootReducer = combineReducers({
  user: userReducer,
  config: configReducer,
});
export const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
});

export const persistor = persistStore(store);

export default store;
